module.exports = __webpack_public_path__ + "img/govava-logo-new.6928f570.png";